// Arrow Button Component
export interface IArrowProps {
  left?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  color?: string; // New prop
  className?: string;
}

export const Arrow: React.FC<IArrowProps> = ({
  left,
  onClick,
  disabled = false,
  color = "white",
  className = "",
}) => {
  return (
    <button
      aria-label={left ? "Previous" : "Next"}
      onClick={onClick}
      disabled={disabled}
      className="p-2 border border-border opacity-70 hover:opacity-100 cursor-pointer transition-all duration-300"
      style={{ [left ? "left" : "right"]: "10px" }}
    >
      <svg
        className={`arrow ${left ? "arrow--left" : "arrow--right"}`}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {left ? (
          <>
            <path
              d="M9.56995 5.92993L3.49995 11.9999L9.56995 18.0699"
              stroke={color}
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={className ? className : ""}
            />
            <path
              d="M20.5 12L3.67 12"
              stroke={color}
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={className ? className : ""}
            />
          </>
        ) : (
          <>
            <path
              d="M14.4301 5.92993L20.5001 11.9999L14.4301 18.0699"
              stroke={color}
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={className ? className : ""}
            />
            <path
              d="M3.5 12L20.33 12"
              stroke={color}
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={className ? className : ""}
            />
          </>
        )}
      </svg>
    </button>
  );
};
